import { useState, useEffect, React } from "react";
import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import api from "../../utils/api";
import "../projects/projects.css";
import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import StarIcon from "@material-ui/icons/Star";

export const Userhostels = () => {
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const [hostels, setHostels] = useState([]);
  const userstate = useSelector((state) => state.loginUserReducer);
  const [hostelRating, setHostelRating] = useState(0);
  const [hostelRatingCount, setHostelRatingCount] = useState(0);
  const [isAlreadyReviewed, setIsAlreadyReviewed] = useState(false);
  const [rating, setRating] = useState(0);
  const { currentUser } = userstate;

  useEffect(() => {
    api
      .get(`/hostels/get-my-hostels/${currentUser?.id}`)
      .then((res) => {
        console.log("hsotels>", res.data);
        setHostels(res.data);
      })
      .catch((err) => console.log(err));
  }, []);
  const deleteHostel = (id) => {
    api
      .delete(`/hostels/${id}`)
      .then((res) => {
        console.log(res.data);
        window.location.reload();
      })
      .catch((err) => console.log(err));
  };

  return (
    <div>
      {/* <Header />
      <Menunav /> */}
      <div className="row">
        {/* <div className="col-md-2 col-0">
          <Sidebar />
        </div> */}
        <div className="col-md-10 col-12">
          <div className="row mt-3">
            {/* <div className="col-6">
              <h3>Hostels:</h3>
            </div>
            <div className="col-6">
              <Link to="/hostels/post" className="btn-link">
                Add Hostel
              </Link>
            </div> */}
          </div>
          <div className="container">
            {/* second first */}
            {hostels?.length > 0 ? (
              hostels
                .sort(function (a, b) {
                  return new Date(b.updatedAt) - new Date(a.updatedAt);
                })
                .map((hostel) => (
                  // <Card sx={{ width: "100%" }}>
                  //   <CardHeader
                  //     avatar={
                  //       <Stack direction="column">
                  //         {currentUser?.profile ? (
                  //           <Avatar
                  //             src={currentUser?.profile}
                  //             alt={currentUser?.name?.at(0)?.toUpperCase()}
                  //           />
                  //         ) : (
                  //           <Avatar
                  //             sx={{ bgcolor: "colorThree.main" }}
                  //             aria-label="recipe"
                  //           >
                  //             {currentUser?.name?.at(0)?.toUpperCase()}
                  //           </Avatar>
                  //         )}
                  //       </Stack>
                  //     }
                  //     title={currentUser?.name?.toUpperCase()}
                  //     subheader={new Date(hostel?.createdAt).toDateString()}
                  //   />

                  //   <CardContent>
                  //     <Typography
                  //       sx={{
                  //         fontSize: "1.5rem",
                  //         marginBottom: "10px",
                  //         fontWeight: "500",
                  //         textTransform: "capitalize",
                  //       }}
                  //       color="fontPrimaryColor.main"
                  //       className="question__title"
                  //       // onClick={() => navigate(`/answers/${question._id}`)}
                  //     >
                  //       {hostel?.hostelName}
                  //     </Typography>
                  //     <Typography variant="body2" color="text.secondary">
                  //       {hostel?.description}
                  //     </Typography>
                  //     {hostel?.hostelImage && (
                  //       <img
                  //         style={{
                  //           margin: "20px 0",
                  //           marginLeft: "50%",
                  //           transform: "translateX(-50%)",
                  //         }}
                  //         height="auto"
                  //         width="60%"
                  //         src={hostel?.hostelImage}
                  //         alt="Paella dish"
                  //       />
                  //     )}
                  //     <Box className="language mt-4 bg-white">
                  //       <Box className="tags bg-white">
                  //         {hostel?.tags?.map((t) => (
                  //           <Typography className="tag-span">{t}</Typography>
                  //         ))}
                  //       </Box>
                  //     </Box>

                  //     <Box className="country mt-4 mb-1">
                  //       <Typography variant="body2" sx={{ fontWeight: "600" }}>
                  //         Location
                  //       </Typography>
                  //       <Typography variant="body2">
                  //         {hostel?.location}
                  //       </Typography>
                  //     </Box>
                  //     <Box className="duration mb-1">
                  //       <Typography variant="body2" sx={{ fontWeight: "600" }}>
                  //         Price per head
                  //       </Typography>
                  //       <Typography>{hostel?.price} PKR</Typography>
                  //     </Box>
                  //     <Box className="duration mb-1">
                  //       <Typography variant="body2" sx={{ fontWeight: "600" }}>
                  //         Meal Price per Month
                  //       </Typography>
                  //       <Typography>{hostel?.mealPrice} PKR</Typography>
                  //     </Box>
                  //     <Box className="amount mb-4 mb-1">
                  //       <Typography variant="body2" sx={{ fontWeight: "600" }}>
                  //         Contact
                  //       </Typography>
                  //       <Typography>{hostel?.contact}</Typography>
                  //     </Box>

                  //     <Box className="applydeadline mb-1">
                  //       <p></p>
                  //     </Box>
                  //   </CardContent>
                  <>
                    <Grid
                      container
                      sx={{
                        boxShadow: "rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px",
                      }}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={4}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {hostel?.hostelImages && (
                          <img
                            style={{
                              margin: "0px 0",
                              marginLeft: "50%",
                              transform: "translateX(-50%)",
                            }}
                            height="auto"
                            width="100%"
                            src={hostel?.hostelImages[0]}
                            alt="Paella dish"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={8} sx={{ padding: "20px 20px" }}>
                        <Typography
                          variant="h5"
                          sx={{
                            textTransform: "whitesmoke",
                            fontWeight: "600",
                          }}
                          className="title-link"
                          onClick={() =>
                            navigate(`/hostel-details/${hostel?._id}`)
                          }
                        >
                          {hostel?.generalData?.hostelName}
                        </Typography>

                        <Typography
                          variant="body2"
                          sx={{ marginBottom: "5px" }}
                        >
                          {hostel?.generalData?.city},{" "}
                          {hostel?.generalData?.state}
                        </Typography>
                        {/* <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "10px",
                          }}
                        >
                          {hostelRating === 0 ? (
                            ""
                          ) : (
                            <>
                              {" "}
                              {Array(parseInt(hostelRating))
                                .fill()
                                .map((_, i) => (
                                  <span>
                                    <StarIcon style={{ color: "gold" }} />
                                  </span>
                                ))}
                              <Typography variant="body2">
                                {parseInt(hostelRating)}
                              </Typography>
                              &nbsp;
                              <Typography variant="body2">
                                ({hostelRatingCount})
                              </Typography>
                            </>
                          )}
                        </Box> */}
                        <Box sx={{ display: "flex" }}>
                          {hostel?.facilities?.map((f) => (
                            <Typography
                              variant="body2"
                              sx={{
                                border: "1px solid lightgray",
                                width: "max-content",
                                padding: "2px 4px",
                                margin: "3px",
                                color: "colorThree.main",
                              }}
                            >
                              {f}
                            </Typography>
                          ))}
                        </Box>

                        <Typography
                          className="ellipsis__two__lines"
                          variant="body2"
                          sx={{ margin: "14px 0", color: "gray" }}
                        >
                          {hostel?.generalData?.hostelDetails}
                        </Typography>

                        {/* <Box className="country mt-2 mb-1 flex">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "fontSecondaryColor.main",
                            width: "150px",
                          }}
                        >
                          Location
                        </Typography>
                        <Typography variant="body2" sx={{ marginLeft: "12px" }}>
                          {hostel?.generalData?.city}
                        </Typography>
                      </Box> */}

                        {/* <Box
                        className="tags bg-white mt-3 mb-3"
                        sx={{ width: "max-content" }}
                      >
                        {hostel?.tags?.map((t) => (
                          <Typography className="tag-span">{t}</Typography>
                        ))}
                      </Box> */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              backgroundColor: "colorThree.main",
                              color: "#fff",
                              padding: "1px 3px",
                            }}
                          >
                            {hostel?.generalData?.hostelCategory}
                          </Typography>
                          <Typography
                            variant="p"
                            sx={{ cursor: "pointer" }}
                            onClick={() =>
                              navigate(`/hostel-details/${hostel?._id}`)
                            }
                          >
                            details
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>

                    <Card>
                      <CardActions>
                        <div className="  mt-3 mb-3 flex-box justify-left ml-auto">
                          <button
                            onClick={() =>
                              navigate(`/edit-hostel/${hostel?._id}`)
                            }
                            className="asc__submit__form__button mr-2"
                          >
                            Edit Hostel
                          </button>
                        </div>
                        <button
                          className=" asc__submit__form__button mr-2"
                          onClick={() => deleteHostel(hostel?._id)}
                        >
                          Delete Hostel
                        </button>
                      </CardActions>
                    </Card>
                  </>
                ))
            ) : (
              <h1>No hostels added</h1>
            )}
          </div>{" "}
          {/*div of container*/}
          {/* <Link to="/hostels/userhostels">
            <button className="btn mt-5 mb-3">User Hostel</button>
          </Link> */}
        </div>{" "}
        {/* div of line 40*/}
      </div>{" "}
      {/*//class name row  */}
    </div> //main div after return
  ); //return ends here
};
